var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.async-dispose.js
// module id = 1100
// module chunks = 0